import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/zh-cn'

export function setupDayjs() {
  dayjs.locale('zh-cn')
  dayjs.extend(relativeTime)
  dayjs.extend(utc)
  dayjs.extend(timezone)
}
